import type { PropsWithChildren } from 'react'
import React, { useCallback } from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import { preventDefault, stopPropagation } from 'lib/web/eventHandlerUtils'

interface Props {
  onClick?: () => void
  isSaved?: boolean
  isProcessing?: boolean
}

function BaseBookmarkButton(props: PropsWithChildren<Props>) {
  const { onClick, isSaved = false, isProcessing = false } = props
  const savedIcon = isSaved ? (
    <SolidHeartIcon colour={isProcessing ? 'neutral-four' : 'favourite'} />
  ) : (
    <LineHeartIcon colour={isProcessing ? 'neutral-four' : undefined} />
  )

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      preventDefault(e)
      stopPropagation(e)

      onClick?.()
    },
    [onClick],
  )

  return (
    <TextButton
      kind="secondary"
      onClick={handleClick}
      disabled={isProcessing}
      size="large"
      startIcon={savedIcon}
    >
      {isSaved ? 'Saved' : 'Save to trip'}
    </TextButton>
  )
}

export default React.memo(BaseBookmarkButton)
